<template>
    <div class="animated fadeIn">
        <div>
            <b-card>
                <div slot="header">
                    <strong style="margin-left: 5px">Create a Category for project "{{ activeProject.name }}"</strong>
                </div>

                <div role="tablist" class="tabbed-form">
                    <b-card no-body class="mb-1">
                        <b-card-header @click="toggleStep(0)" header-tag="header" class="p-1 form-step-name" role="tab">
                            <img src="../../assets/gcp-icons/step1.png" />
                            {{ tabs[0] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[0]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group label="Name" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.formData.name.$model"
                                                    type="text"
                                                    ref="category-name"
                                                    placeholder="Enter the category name"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('formData.name', 0)"
                                                    invalid="This field is required"
                                                    valid="Name is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <Feedback :state="categoryError.state" :invalid="categoryError.message"></Feedback>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('formData.name', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="createCategory"
                                                :disabled="checkPage[0] && $v.formData.name.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Create
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-card>
        </div>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'

import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            tabs: ['Category settings'],
            tabIndex: 0,
            formData: {
                name: null,
            },
            categoryError: {
                state: true,
                message: '',
            },
        }
    },
    mixins: [validationMixin],
    validations: {
        formData: {
            name: {
                required,
            },
        },
    },
    components: {
        Feedback,
        Loading,
    },
    computed: {
        ...mapGetters({
            activeProject: 'project/active',
        }),
        tabOpen() {
            return this.tabs.map((tab, index) => (index === this.tabIndex ? true : false))
        },
    },
    async created() {
        this.checkPage = this.tabs.map(el => false)
    },
    methods: {
        createCategory() {
            this.checkPage[0] = true
            this.$forceUpdate()
            if (!this.$v.$invalid) {
                this.$v.$reset()

                const data = {
                    categoryData: {
                        name: this.formData.name,
                        projectId: this.activeProject.id,
                    },
                }

                this.$store.commit('loading/PROCESSING', `Creating the Category...`)
                this.$store
                    .dispatch('category/createCategory', data)
                    .then(category => {
                        this.$store.commit('loading/PROCESSED')
                        this.$router.push({
                            path: '/codelabs',
                        })
                    })
                    .catch(exception => {
                        this.categoryError.state = false
                        this.categoryError.message = exception.response.data
                        this.$store.commit('loading/PROCESSED')
                    })
            }
        },

        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },

        toggleStep(step) {
            this.tabIndex = step
            this.$forceUpdate()
        },
    },
}
</script>
